import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import axios from 'axios'
import Dayjs from 'dayjs';
import MSALWrapper from "./authUtils";


import "@/design/index.scss";

import store from '@/state/store'

import App from './App.vue'

import i18n from './i18n'

import AppConfig from "./app.config.json";

import tinymce from 'vue-tinymce-editor'
Vue.component('tinymce', tinymce)

Vue.prototype.$dayjs = Dayjs
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

let redirectUrl = window.location.origin;
let msalUtils = new MSALWrapper(redirectUrl);
Vue.prototype.$msal = msalUtils;

var verifTokenExpiration = async (config) => {
  //verif expiration
  let currentAccount = Vue.prototype.$msal.currentAccount;
  if(currentAccount != null){
    const token = await Vue.prototype.$msal.getToken();
    if (token) {
      Object.assign(config, {headers: {authorization: "Bearer " + token}});
    }
  }
  return config;
}

let axiosMainClient = axios.create({
  baseURL: AppConfig.api
});

axiosMainClient.interceptors.request.use(
  verifTokenExpiration,
  (error) => Promise.reject(error)
);
Vue.prototype.$axiosMainClient = axiosMainClient;

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.component('apexchart', VueApexCharts);
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
